import React from 'react';
import { Callout } from '../deck/Callout';
import { StepList } from '../deck/StepList';
import { StepSlide } from '../deck/StepSlide';
import { BackupCodesMockup } from '../mockups/BackupCodesMockup';
export function BackupCodesSlide() {
  return <StepSlide step={5} title="Save your backup codes" visual={<BackupCodesMockup data-id="element-194" data-mp="37rdiguhmhfnn" />} visualLabel="A sheet of paper with backup codes written down by hand" data-id="element-193" data-mp="3cocan7hq7cj7">
      <StepList items={[<>
            Stripe then shows you a list of <strong data-id="element-196" data-mp="2f2exlpm47zen">backup codes</strong>.
          </>, <>
            <strong data-id="element-197" data-mp="2t1o41xkirf5f">Write them all down</strong> on paper.
          </>, <>
            Keep the paper somewhere safe, <strong data-id="element-198" data-mp="2ozb8g1zhkxmd">not on your computer</strong>.
          </>]} data-id="element-195" data-mp="2k0zzrukxgt5q" />
      <Callout title="Why it matters:" data-id="element-199" data-mp="8anq3y1bf9ry">
        Backup codes let you get into the account if you ever lose your phone.
      </Callout>
      <Callout tone="warn" data-id="element-200" data-mp="48kb4zfftn1x">Don't share the QR code or backup codes with anyone.</Callout>
    </StepSlide>;
}